import axios from './../api.js'

const state = {}

const getters = {}

const mutations = {}

const actions = {
    login: ({ dispatch, commit }, userCredentials) => {
        return axios.post('/Account/SignIn', userCredentials).then((response) => {
            return response.data
        }, (response) => {
            commit('errorHandler', response)
            throw response
        })
    },
    setNewPasswordAsync: ({ commit }, email) => {
        return axios.post('/Account/NewPasswordAsync', {username: email}).then((response) => {
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/login/login.js